import { FormInputsHeader } from "features/CenterContent/RoleContent/ProductionDeviation/components/FormInputsHeader";
import { ProductionDeviationSteps } from "features/CenterContent/RoleContent/ProductionDeviation/ProductionDeviationModal";
import { ProductionDeviationOverviewTrainSeries } from "features/CenterContent/RoleContent/ProductionDeviation/steps/ProductionDeviationOverviewTrainSeries";
import { PANEL_STYLE } from "features/CenterContent/RoleContent/ProductionDeviation/utils";
import { OperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { ActionModal } from "shared/components/ActionModal";

type ProductionDeviationProps = {
  isEditMode: boolean;
  onClose: () => void;
  onSubmit: () => void;
  setActiveStep: Dispatch<SetStateAction<number>>;
  trainSeries: string[];
  trainSeriesIndex: number;
  setTrainSeriesIndex: Dispatch<SetStateAction<number>>;
  opInfoData: OperationalInformationTypes;
  status: "error" | "idle" | "pending" | "success";
};

export const ProductionDeviationOverview: FC<ProductionDeviationProps> = ({
  isEditMode,
  onClose,
  onSubmit,
  setActiveStep,
  trainSeries,
  trainSeriesIndex,
  setTrainSeriesIndex,
  opInfoData,
  status,
}) => {
  const { t } = useTranslation();
  return (
    <ActionModal
      title={`${isEditMode ? t("Endre") : t("Opprett")} ${t("produksjonsavvik")}`}
      actionTitle={`${isEditMode ? t("Endre") : t("Opprett")}`}
      onClose={onClose}
      onBack={() => setActiveStep(ProductionDeviationSteps.TRAINIDS)}
      onSubmit={onSubmit}
      loading={status === "pending"}
      isSuccess={status === "success"}
      isError={status === "error"}
      successMessage={
        isEditMode
          ? t("Produksjonsavvik endret")
          : t("Produksjonsavvik opprettet")
      }
      failureMessage={`${
        isEditMode
          ? t("Kunne ikke endre produksjonsavvik.")
          : t("Kunne ikke opprette produksjonsavvik.")
      } ${t("Prøv på nytt, eller kontakt IT hvis feilen vedvarer.")}`}
      size="xl"
      contentBodyStyle={PANEL_STYLE}
      subHeaders={[
        <FormInputsHeader
          trainSeries={trainSeries}
          trainSeriesIndex={trainSeriesIndex}
          opInfoData={opInfoData}
          toFormInputsStep={() => setActiveStep(ProductionDeviationSteps.FORM)}
        />,
        ...trainSeries.map((trainSerie, index) => (
          <ProductionDeviationOverviewTrainSeries
            trainSerie={trainSerie}
            toStep={() => {
              setTrainSeriesIndex(index);
              setActiveStep(ProductionDeviationSteps.TRAINIDS);
            }}
          />
        )),
      ]}
    />
  );
};
